// Zentrale Feature-Flags für das Frontend
// Klein gehalten, damit wir zur Laufzeit einfach umschalten können (z.B. via ENV)

export function isGalleryCarouselEnabled(): boolean {
  const raw = import.meta.env.VITE_FEATURE_GALLERY_CAROUSEL;
  if (typeof raw === 'string') {
    return raw === '1' || raw.toLowerCase() === 'true';
  }
  return true;
}



